export const UPDATE_UA_KEY_EVENTS_NAME = "update_user_analytics_key_events";

export const UPDATE_UA_KEY_EVENTS_DESC = `Sets User Analytics key events (conversion / KPI event names) for a project.

Use when the user wants to define which GA-style events count as key events for User Analytics (for example "purchase", "generate_lead").

Input:
- 'keyEvents' (required): Non-empty array of event name strings (e.g. ["purchase", "subscribe"]).
- Provide scope with exactly one of:
  - 'userAnalyticsId': User Analytics node ID, OR
  - 'projectId': User Analytics Project ID (the tool resolves User Analytics from the project).

Notes:
- Write operation (mutation via updateUserAnalytics). Requires confirmation.
- Replaces the full key events list; include every event name you want to keep.`;
